import React, { useRef, useEffect, useState } from "react";
import { Box, Grid, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { motion } from "framer-motion";
import { Link } from 'react-router-dom';

const DecisionLog2 = ({ 
    decisionData,
    currentDecision,
    setCurrentDecision 
}) => {
  // console.log("Rendering DecisionLog2");
  // console.log("Decision Data:", decisionData);
  // console.log("currentDecision:", currentDecision);

  const logContainerRef = useRef(null);
  const [logCount, setLogCount] = useState(0);

  const logEntries = Object.keys(decisionData)
    //.filter((key) => parseInt(key) <= currentDecision)
    // Only show entries for decisions that have been made, i.e. those with an option that is marked chosen
    .filter((key) => decisionData[key].options.some(opt => opt.chosen))
    .map((key) => ({
      decision: `Decision (${key})`,
      question: decisionData[key].question,
      answer: decisionData[key].options.find(opt => opt.chosen)?.option || "No answer selected",
    }));

  return (
    <Box>
      {/* <Typography variant="h6" mb={2}>
        Decision Log
      </Typography> */}
      <LogContainer ref={logContainerRef}>

        {/* <LogTitle variant="h6">Decision log</LogTitle> */}

        <LogTable style={{ width: "100%" }}>
          <LogHeader container>
            <HeaderCell item xs={3}></HeaderCell>
            <HeaderCell item xs={3}>Question</HeaderCell>
            <HeaderCell item xs={3}>Answer</HeaderCell>
          </LogHeader>
          {logEntries.map((entry, index) => (
              <LogEntry container key={index}>
                <DecisionCell item xs={3}>
                  <Link onClick={() => setCurrentDecision(parseInt(entry.decision.split("(")[1]))}>
                    {entry.decision}
                  </Link>
                </DecisionCell>
                <Cell item xs={3}>
                  <AnimatedCell initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }}>
                    {entry.question}
                  </AnimatedCell>
                </Cell>
                <Cell item xs={3}>
                  <AnimatedCell initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }}>
                    {entry.answer}
                  </AnimatedCell>
                </Cell>
              </LogEntry>
          ))}
        </LogTable>
      </LogContainer>
    </Box>
  );
};


const StyledTitle = styled(Typography)(({ theme }) => ({
  fontFamily: "'Inter', sans-serif",
  fontWeight: 700,
  fontSize: "20px",
  lineHeight: "24px",
  textDecoration: "underline",
  color: "#303030",
}));

const InfoWrapper = styled(Box)(({ theme }) => ({
  fontSize: "14px",
  fontWeight: 400,
  marginTop: "30px",
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  alignItems: 'flex-start',
  [theme.breakpoints.down("md")]: {
    maxWidth: "100%",
  },
  "& p": {
    marginBottom: "10px",
  },
  "& ul": {
    listStyleType: "none",
    paddingLeft: 0,

  },
  "& li": {
    marginBottom: "5px",
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));

const Divider = styled(Box)(({ theme }) => ({
  borderBottom: `1px dashed #303030`,
  width: "100%",
  margin: theme.spacing(2, 0),
}));

const LogContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  // marginTop: theme.spacing(6),
  fontFamily: "Inter, sans-serif",
  color: theme.palette.text.primary,
  maxHeight: '100%',
  padding: '1.3rem',

  width: '94%',

  // [theme.breakpoints.up('md')]: {
  //   maxWidth: '800px', 
  //   minWidth: '700px',
  // },
  [theme.breakpoints.down('md')]: {
    maxWidth: '100%',
    minWidth: 'auto',
    padding: '0 20px',
  },
}));

const LogTitle = styled(Typography)(({ theme }) => ({
  textAlign: "center",
  marginBottom: theme.spacing(3),
  fontFamily: "'Inter', sans-serif",
  fontStyle: "normal",
  fontWeight: 700,
  fontSize: "20px",
  lineHeight: "24px",
  textDecorationLine: "underline",
  fontFeatureSettings: "'tnum' on, 'lnum' on",
  color: "#303030",
}));

const LogTable = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  width: "100%",
  maxWidth: "1000px",

}));

const LogHeader = styled(Grid)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  fontSize: 18,
  fontWeight: 600,
}));

const HeaderCell = styled(Grid)(({ theme }) => ({
  padding: theme.spacing(0, 2.5),
  fontFamily: "'Inter', sans-serif",
  fontStyle: "normal",
  fontWeight: 500,
  fontSize: "20px",
  lineHeight: "24px",
  fontFeatureSettings: "'tnum' on, 'lnum' on",
  color: "#303030",
}));

const LogEntry = styled(Grid)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  padding: theme.spacing(1.5, 0), // Vertical spacing between log entry rows
  fontSize: 14,
  fontWeight: 400,
}));

const DecisionCell = styled(Grid)(({ theme }) => ({
  paddingLeft: theme.spacing(2.5),
  fontFamily: "'Inter', sans-serif",
  fontStyle: "normal",
  fontWeight: 500,
  fontSize: "20px",
  lineHeight: "24px",
  fontFeatureSettings: "'tnum' on, 'lnum' on",
  color: "#303030",
}));

const Cell = styled(Grid)(({ theme, isPending }) => ({
  paddingLeft: theme.spacing(2.5),
  fontFamily: "'Inter', sans-serif",
  fontStyle: isPending ? "italic" : "normal",
  fontWeight: isPending ? 400 : 400,
  fontSize: isPending ? "12px" : "12px",
  lineHeight: isPending ? "15px" : "14px",
  fontFeatureSettings: "'tnum' on, 'lnum' on",
  color: isPending ? "#D9D9D9" : "#303030",
}));

const AnimatedCell = styled(motion.div)`
  display: inline-block;
`;

export default DecisionLog2;
